import React, { useState, useEffect } from "react";

import StarsIcon from "@material-ui/icons/Stars";
import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";

import { MenuCustom, MenuCustomItem } from "../ui/Menu";

import "../../css/submissionFields.css";
import CommonConstants from "../../constants/CommonConstants";
import StringUtils from "../../utils/StringUtils";
import NuxeoClient from "../../clients/NuxeoClient";
import { JobConfirmationModal } from "./Modals";

import { useI18n } from "../../I18nProvider";

export function FavMenu(props) {
  const appText = useI18n();
  const [anchorEL, setAnchorEL] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [timeID, setTimeID] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteName, setFavoriteName] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [selectedJob, setSelectedJob] = useState();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (
      props.licenseePath !== null &&
      props.user !== null &&
      isFetching === false
    ) {
      setIsFetching(true);
      setIsLoading(true);
      fetchJobs();
    }
  }, [props.licenseePath]);

  useEffect(() => {
    if (
      props.licenseePath !== null &&
      props.user !== null &&
      isFetching === false
    ) {
      setIsFetching(true);
      setIsLoading(true);
      fetchJobs();
    }
  }, [props.user]);

  async function fetchJobs(input = "", searchFavorites = true) {
    if (props.user.id !== null) {
      await NuxeoClient.instance()
        .fetchJobs(input, props.licenseePath, props.user.id, searchFavorites)
        .then((res) => {
          let fetchedJobs = res.entries.filter(
            (entry) => entry.type === props.docType
          );
          fetchedJobs.sort(
            (a, b) =>
              new Date(b.properties["dc:created"]) -
              new Date(a.properties["dc:created"])
          );
          if (searchFavorites) {
            fetchedJobs = fetchedJobs.filter(
              (job) => job.properties["submission:isFavorite"] === true
            );
          }
          setFetchedData(fetchedJobs);
          setIsLoading(false);
          setIsFetching(false);
        });
    }
  }

  const loadJobs = (input) => {
    setIsLoading(true);
    setTimeID((timeID) => [
      ...timeID,
      setTimeout(() => fetchJobs(input, input === "" ? true : false), 2000),
    ]);
    timeID.forEach((time) => window.clearTimeout(time));
  };

  async function handleRemove(job) {
    setFetchedData(fetchedData.filter((data) => data.title !== job.title));

    job.properties["submission:isFavorite"] = false;
    job.properties["submission:favoriteName"] = null;

    await NuxeoClient.instance().updateJob(job);

    fetchJobs();
  }

  const handleChange = (value) => {
    setIsFavorite(value);
    props.handleChange("isFavorite", value);
    if (value) {
      props.handleChange("favoriteName", favoriteName);
    }
    if (!value) {
      handleCustomChange(value);
    }
  };

  const handleInputChange = (event) => {
    setFavoriteName(event.target.value);
  };

  const handleCustomChange = (value) => {
    setIsEditable(value);
    props.handleChange("isEditable", value);
  };

  const langJP = () => {
    const lang = navigator.language || navigator.userLanguage;
    if (lang.startsWith("ja")) {
      return true;
    }
    return false;
  };
  const customMenu = isEditable ? (
    <MenuCustomItem>
      <EditIcon style={{ marginRight: "2%" }} />
      <form>
        <input
          type="text"
          placeholder="Click to edit name"
          id="favName"
          onChange={(event) => handleInputChange(event)}
        />
      </form>
      <button onClick={() => handleChange(true)}>{appText.T141}</button>
    </MenuCustomItem>
  ) : (
    <MenuCustomItem onClick={() => handleCustomChange(true)}>
      <AddIcon style={{ marginRight: "2%" }} />
      <i>{appText.T139}</i>
    </MenuCustomItem>
  );

  return (
    <div>
      <StarsIcon
        id="fav-icon"
        onClick={(event) => setAnchorEL(event.currentTarget)}
      />
      <MenuCustom
        id="simple-menu"
        anchorEl={anchorEL}
        keepMounted
        open={Boolean(anchorEL)}
        onClose={() => {
          setAnchorEL(null);
          setShowSearch(false);
          fetchJobs();
        }}
      >
        <MenuCustomItem onClick={() => setShowSearch(true)}>
          {showSearch ? (
            <TextField
              fullWidth={true}
              className="textArea-field"
              autoFocus={true}
              aria-label="minimum height"
              rows={1}
              disableUnderline={false}
              onChange={(event) => loadJobs(event.target.value)}
            />
          ) : (
            <SearchIcon />
          )}
        </MenuCustomItem>
        {isLoading ? (
          <MenuCustomItem>
            <div
              style={{
                width: "25vw",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {/* Loading... */}
              {appText.T140}
              <CircularProgress size={20} />
            </div>
          </MenuCustomItem>
        ) : fetchedData.length > 0 ? (
          fetchedData.map((job, index) => {
            if (index < 10) {
              return (
                <div id="menu-item" key={index}>
                  <div
                    style={{
                      width: "25vw",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Tooltip
                      placement="top-start"
                      title="Auto-fill the form values with this job's information"
                    >
                      <div
                        onClick={() => {
                          setSelectedJob(job.properties);
                          setShowModal(true);
                          setAnchorEL(null);
                        }}
                      >
                        {job.properties["submission:favoriteName"] ||
                          StringUtils.cutName(job.title)}
                      </div>
                    </Tooltip>
                    {job.properties["submission:isFavorite"] ? (
                      <Tooltip
                        placement="top-start"
                        title="Remove this job from favourites"
                      >
                        <DeleteIcon
                          style={{ fontSize: 19 }}
                          onClick={() => handleRemove(job)}
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                </div>
              );
            }
          })
        ) : (
          <div>
            <MenuCustomItem>
              {/* {CommonConstants.NO_JOB_MESSAGE + props.licensee + appText.T138} */}
              {langJP
                ? props.licensee + appText.T138
                : appText.T138 + props.licensee}
            </MenuCustomItem>
          </div>
        )}
        {!isFavorite ? (
          customMenu
        ) : (
          <MenuCustomItem>
            <div
              style={{
                width: "25vw",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <DoneIcon style={{ marginRight: "2%", color: "green" }} />{" "}
                <i>Submission added to favorites</i>
              </div>
              <DeleteIcon
                style={{ fontSize: 19 }}
                onClick={() => handleChange(false)}
              />
            </div>
          </MenuCustomItem>
        )}
      </MenuCustom>

      <JobConfirmationModal
        open={showModal}
        showModal={setShowModal}
        setJobInfo={props.setJobInfo}
        job={selectedJob}
      />
    </div>
  );
}
